export const getElement = (selector: string): Element => document.querySelector(selector);
